import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, dark = false }) {
  return (
    <span className={`inline-block text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] ${dark ? "text-brand-orange" : "text-brand-orange"}`}>
      {children}
    </span>
  );
}
